import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagesStatusService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/tags";

   url2 = environment.serverAPI10 + "/api/sequencesTags";

  newTags(tagesStatus: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, tagesStatus)
  }

  Tags(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  getTagsById(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/${leadId}`);
  }
  getAllTagsDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  TagsSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  syncTagsPageData() {
    return this.http.get(`${this.url}/page/sync`);
  }


  public responseCache = new Map();

  public getAllTagsDropDownCache(type: any): Observable<any> {

    const dealStagesFromCache = this.responseCache.get(`${this.url}/dropdown?type=${type}`);

    if (dealStagesFromCache) {
      return of(dealStagesFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown?type=${type}`).pipe(
        tap(leadStatus => this.responseCache.set(`${this.url}/dropdown?type=${type}`, leadStatus))
      );
    }

  }

    getAllTagsDropDownSequence(type: any): Observable<Object> {
    return this.http.get(`${this.url2}/dropdown?type=${type}`);
  }


}
